import { isUndNullEmpNew } from "../../helpers/UtilsHelper";

export class LargeLanguageModelClass {
    constructor(
        id = '',
        code = '',
        description = '',
        enabled = '',
        userId = '',
        created = new Date()?.toISOString(),
    ) {
        this.id = id;
        this.code = code;
        this.description = description;
        this.enabled = enabled;
        this.userId = userId;
        this.created = created;
    }

    static getClassName() {
        return 'language large model - class';
    }

    static getClass(obj = Object) {
        if (!isUndNullEmpNew({ data: obj, subMethod: this?.getClassName() })?.result) {
            return new LargeLanguageModelClass(
                obj?.id,
                obj?.code,
                obj?.description,
                obj?.enabled,
                obj?.userId,
                obj?.created,
            );
        }
        return new LargeLanguageModelClass();
    }
}